import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import user from './slices/userSlice'
import event from './slices/eventSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        user,
        event,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
